<template>
  <div class="root">
    <header>Virtual Items Policy</header>
    <div>1.How you can got Golds</div>
    <b> In-App Purchaser </b>
    <ur>
      <li>
        From time to time. We may offer "Golds" for purchase through the App
        Store Google Play or other application platforms (in-app purchases"). If
        you choose to make an in-app purchase, you will be prompted to enter
        details for your account with the mobile platfoHabarm you are using (e.g..
        Apple, Android, etc.) ('your IAP Account'), and your IAP Account will be
        charged for the in-app purchase in accordance with the terms disclosed
        to you at the time of purchase as well as the general terms for in-app
        purchases that apply to your IAP Account. The price of the Golds will be
        displayed at the point of purchase All charges and payments for Golds
        will be made in the currency specified at the point of purchase through
        the relevant payment mechanisn Currency exchange settlements, foreign
        transaction fees and payment channel fees, if any, are based on your
        agreement with the applicable payment provider
      </li>
    </ur>
    <ur>
      <li>
        You will be responsible for the payment of any Golds purchased by you.
        Once your purchase has been completed, your user account will be
        credited with Golds
      </li>
    </ur>
    <ur>
      <li>
        If you live in the European Union, you have certain rights to withdraw
        from a purchase under the Consumer Rights Directive and its implementing
        legislation However, if you purchase Golds, you acknowledge and agree
        that we start supplying the Golds to you promptly once the purchase is
        complete and therefore your right to cancel or withdraw from agreement
        to purchase is lost at this point
      </li>
    </ur>
    <p>You can also collect Golds through the following ways</p>
    <p>(1)Participate in campaigns and activities</p>
    <p>(2)Operate his/her own room to win Golds as rewards</p>
    <p>(3)Sign-in may give you Golds at random</p>
    <p>
      (4) Other methods Haba may add There is no obvious difference between
      the Golds collected and purchased by the user through the above mothods
      and user can use them for the same Service as well in Haba. However,
      because the Golds collected by users through the above methods are
      generated by the system and are NOT purchased by user, you agrer that
      Haba has the absolute right to manage, regulate. control, modify and/or
      eliminate such Golds as it sees fit in its sole discretion, in any general
      or specific case, and that Haba will have no liability to you based on
      its exercise of such right
    </p>
    <div>2.How you can use Golds</div>
    <p>
      <b> Goids can be used to </b>
    </p>
    <p>(1)Send virtual gifts to others</p>
    <p>(2)Participate in games</p>
    <p>(3)Create rooms</p>
    <p>Other existing uses and uses Haba may add in the future</p>
    <ur>
      <li>
        Haba have the right to adjust the uses and usage rules of Golds from
        time to time
      </li>
    </ur>
    <ur>
      <li>The Golds in your account will be consumed because they are used</li>
    </ur>
    <ur>
      <li>
        When you have exchanged your Golds for Gifts, such Golds will be
        deducted from your user account and credited with Gifts
      </li>
    </ur>
    <ur>
      <li>
        Gifts cannot be converted into on exchanged for Golds or cash, or be
        refunded or reimbursed by us for any reason
      </li>
    </ur>
    <ur>
      <li>
        Please note that when you give a Gift to another user or gifts to users
        you do so publically so other users on the services (including the
        recipient/recipients of the Gift/Gifts) can see your name, and the
        details of the Gift that you gave. By giving a Gift, you consent to this
        information being made available in this manner. In this process, the
        protection of personal data will comply with the provisions of our
        Privacy Policy
      </li>
    </ur>
    <ur>
      <li>
        Golds cannot be exchanged for cash, or legal tender, or currency of any
        state region, or any political entity, or any other form of credit Golds
        can only be used on Haba and as part of our services, and cannot be
        combined or used in conjunction with other promotions, coupons,
        discounts or special offers, except those designated by .
      </li>
    </ur>
    <ur>
      <li>
        No Golds may be assigned or transferred to any other user of the
        services or third party except as expressly permitted by us in writing.
        The sale barter, assignment or other disposal of any Golds, other than
        by us, is expressly prohibited
      </li>
    </ur>
    <ur>
      <li>
        Accrued Golds do not constitute property and are not transferable: (a)
        upon death: (b) as part of a domestic relations matter, or (c) otherwise
        by operation of law Any Golds assigned, sold, or otherwise transferred
        without the express writter consent of us are void.
      </li>
    </ur>
    <ur>
      <li>
        Any user of the services who violates this restriction may have his or
        her account terminated by us have Golds forfeited from his or her
        account, and/or be subject to liability for damages and litigation and
        transaction costs
      </li>
    </ur>
    <ur>
      <li>
        All Golds of a user will expire automatically upon termination of such
        user's account for any reason We reserve the right to deduct Golds from
        your account if the user acquire them by illegal or fraud way.
      </li>
    </ur>
    <ur>
      <li>
        You agree that we have the right to manage, regulate. control modify
        and/or eliminate such Golds, where we have a valid reason to do so such
        as where we reasonably believe you have violated this Policy, you are in
        breach of any applicable law oc regulation or for legal, security or
        technical reasons and that we will have no liability to you based on our
        exercise of such right. If we decided to eliminate Golds from our
        services completely, w will do so by providing reasonable notice to you
      </li>
    </ur>
    <ur>
      <li>
        You agree that in any general or specific circumstances, we have full
        discretion to manage, adjust. control, modify and/or eliminate the golds
        that we deem appropriate and that we will have no liability to you based
        on our exercise of such right
      </li>
    </ur>
    <p>
      <b> Special description </b>
    </p>
    <p>
      Virtual items and subscription services require users to purchase from
      officially approved channels such as App Store and Google Play through
      their IAP accounts. Handing over your account to others for operation, or
      conducting private transactions with others, or malicious refunds after
      recharging are all violations of the platform rules. These actions will
      disrupt the normal management of the platform, and will also pose a hazard
      to your account and personal information. In response to this type of
      behavior, the platform will take measures including but not limited to the
      following:
    </p>
    <ur>
      <li>
        Take back all the virtual currency and purchased items in the account
        suspected of proxy charging or malicious refund;
      </li>
    </ur>
    <ur>
      <li>
        Freeze all remaining virtual items in the account until the refund is
        completed;
      </li>
    </ur>
    <ur>
      <li>Time-limited or permanent ban on the account.</li>
    </ur>
    <p>
      You may cancel your account at any time, and Haba may terminate your
      account in accordance with the Terms. All the Golds in your account will
      be forfeited immediately upon the cancellation or termination of your
      account. There will be no refunds for any unused or unredeemed Golds. So
      we recommend that you use them before terminating your account. If you
      have any problems with Golds, please contact us in Haba APP Feedback in
      Settings or email report@habagogo.com
    </p>
  </div>
</template>

<script>
export default {
  name: "privacy",
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.root {
  text-align: left;
  margin: 10px;
}
header {
  padding: 10px;
  text-align: center;
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 10px;
  font-weight: 900;
}
div {
  font-size: 25px;
  font-weight: 900;
}
b {
  font-size: 20px;
  font-weight: 900;
}

p {
  font-size: 16px;
  font-weight: 500;
}
table {
  border-collapse: collapse;
}

th,
td {
  border: 1px solid black;
  padding: 8px;
  text-align: left;
}
td,
li {
  font-size: 16px;
}
a {
  color: blue;
}
</style>
